import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout, PersonalPath } from 'entities/ExportRouters'

export const ApplicationsAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.applications}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: `/${PersonalPath.profile}`,
        })
      }}
    />
  )
})
